import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DriverRuleKey, DRIVER_RULES, ShiftEvaluation } from '../../types';

/**
 * Drill-down for a single shift evaluation. Surfaces:
 *   - the driver-eligibility verdict (driverEligibleAtClose),
 *   - whether the floor top-up was applied,
 *   - the four rule results with their (defensively rendered) violations.
 */
@Component({
  selector: 'lohi-ppp-shift-detail-dialog',
  templateUrl: './ppp-shift-detail-dialog.component.html',
  styleUrls: ['./ppp-shift-detail-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PppShiftDetailDialogComponent {
  public readonly shift: ShiftEvaluation;
  public readonly ruleKeys: DriverRuleKey[] = [
    DRIVER_RULES.NO_LOAD_REJECTIONS,
    DRIVER_RULES.NO_MISSED_ACCEPTANCES,
    DRIVER_RULES.GPS_ALWAYS_ON,
    DRIVER_RULES.NO_LATE_ARRIVALS,
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { shift: ShiftEvaluation },
    private dialogRef: MatDialogRef<PppShiftDetailDialogComponent>,
  ) {
    this.shift = data.shift;
  }

  public close(): void {
    this.dialogRef.close();
  }

  public ruleFor(key: DriverRuleKey) {
    return this.shift.rulesCheck?.[key];
  }

  public trackByRuleKey(index: number, key: DriverRuleKey): string {
    return key;
  }
}
